import { Component, Output, Input, EventEmitter } from '@angular/core';
import { PlpVariantRestyleService } from '~shared/services/plp-variant-restyle/plp-variant-restyle.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-select',
  templateUrl: './mm-select.component.html',
  styleUrls: ['./mm-select.component.scss'],
})
export class MmSelectComponent {
  isPLP: boolean;
  isNewPLPVariantRestyle$: Observable<boolean>;
  @Input()
  labelId: string;
  @Input() mmTestTarget = 'search-select';
  @Output() selected = new EventEmitter<any>();

  constructor(private plpVariantRestyleService: PlpVariantRestyleService) {
    this.isNewPLPVariantRestyle$ = this.plpVariantRestyleService.isNewPLPVariantRestyle();
    this.isPLP = this.plpVariantRestyleService.isPLP();
  }

  onSelectChange(value) {
    this.selected.emit(value);
  }
}
